import { render, staticRenderFns } from "./knowledgeContent.vue?vue&type=template&id=f0042822"
import script from "./knowledgeContent.vue?vue&type=script&lang=js"
export * from "./knowledgeContent.vue?vue&type=script&lang=js"
import style0 from "./knowledgeContent.vue?vue&type=style&index=0&id=f0042822&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports